import { getJsNow } from 'utils/date';
import * as taskHelpers from 'resources/task/task.helpers';
import taskService from 'resources/task/task.service';
import { TASK_STATUSES } from 'resources/task/task.constants';

const markTaskCompleted = async (task) => {
  // Tasks & Emails
  if (taskHelpers.isDefault(task) || taskHelpers.isEmailTemplate(task)) {
    return taskService.updateTask({
      id: task.id,
      status: TASK_STATUSES.COMPLETED,
      completed_on: getJsNow(),
      completed_by: null,
    });
  }

  // Document Requests
  return taskService.updateTask({
    id: task.id,
    is_optional: true,
    is_skipped: true,
    is_hidden_from_client: true,
  });
};

const markTaskSkipped = async (task) => taskService.updateTask({
  id: task.id,
  is_optional: true,
  is_skipped: true,
  is_hidden_from_client: true,
});

const markAllCompleted = async (tasks) => Promise.all(tasks.map((task) => markTaskCompleted(task)));

const markAllSkipped = async (tasks) => Promise.all(tasks.map((task) => markTaskSkipped(task)));

export { markAllSkipped, markAllCompleted, markTaskSkipped };
